<script>
	import {replace} from "svelte-spa-router";
	import UserController from "../controladores/user.svelte";
	let controlador;
	let usuario = "",pass="";
	function login(){
		controlador.login(usuario,pass);
		usuario = ""; pass = "";
	}
</script>
<UserController bind:this={controlador} />
<div class="container flex flex-col w-screen h-screen max-w-full max-h-full bg-purple-300 items-center justify-center">
	<div class="flex w-auto flex-col px-24 m-4 items-center justify-center bg-gray-100 rounded shadow">
		<div class="font-bold m-10">PAW5</div>
		<input bind:value={usuario} class="m-4 px-2 border-2 border-pink-300" type="text" placeholder="Usuario" />
		<input bind:value={pass} class="m-4 px-2 border-2 border-pink-300" type="password" placeholder="Contreseña" />
		<button on:click={login} class="m-4 px-2 bg-purple-400 hover:bg-purple-500 text-white rounded" >Ingresar</button>
	</div>
</div>
